import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCWaEsYO3xEf9BwMKlUzpi0ebX_kM7VE20",
  authDomain: "mobileplus-171b6.firebaseapp.com",
  projectId: "mobileplus-171b6",
  storageBucket: "mobileplus-171b6.firebasestorage.app",
  messagingSenderId: "157252001942",
  appId: "1:157252001942:web:a9b195d316f943fcf1a2b7",
  measurementId: "G-TEFLL15EQS",
};

const app = initializeApp(firebaseConfig); 

export const auth = getAuth(app);
export const db = getFirestore(app);